// Duits (de-DE), design: zelfde vorm als design.nl.ts. Pictogramnamen kort en eenvoudig (ook voor
// kinderen); zoekwoorden in het Duits plus de internationale woorden uit nl (namaz, salah, kuran …).
// Wat ontbreekt valt terug op het Nederlands (nooit een rauwe sleutel op het scherm).
export const designDe = {
    picto: {
        'brush-teeth': 'Zähne putzen',
        'get-dressed': 'Anziehen',
        shoes: 'Schuhe an',
        coat: 'Jacke an',
        'wash-hands': 'Hände waschen',
        toilet: 'Aufs Klo',
        shower: 'Duschen',
        bath: 'Baden',
        sleep: 'Schlafen',
        alarm: 'Wecker',
        prayer: 'Beten',
        wudu: 'Wudu machen',
        'make-bed': 'Bett machen',
        'tidy-up': 'Aufräumen',
        'set-table': 'Tisch decken',
        'clear-table': 'Tisch abräumen',
        dishes: 'Abwaschen',
        dishwasher: 'Spülmaschine ausräumen',
        vacuum: 'Staubsaugen',
        sweep: 'Fegen',
        cleaning: 'Putzen',
        windows: 'Fenster putzen',
        laundry: 'Wäsche waschen',
        'fold-laundry': 'Wäsche falten',
        trash: 'Müll rausbringen',
        recycling: 'Müll trennen',
        'water-plants': 'Pflanzen gießen',
        garden: 'Garten',
        'walk-dog': 'Mit dem Hund raus',
        'feed-cat': 'Katze füttern',
        'feed-fish': 'Fische füttern',
        'feed-rabbit': 'Kaninchen füttern',
        mail: 'Post',
        school: 'Schule',
        backpack: 'Schulranzen',
        homework: 'Hausaufgaben',
        reading: 'Lesen',
        library: 'Bücherei',
        lecture: 'Vortrag',
        mosque: 'Moscheeunterricht',
        quran: 'Koran',
        computer: 'Computer',
        work: 'Arbeit',
        'phone-call': 'Telefonieren',
        calendar: 'Termin',
        soccer: 'Fußball',
        hockey: 'Hockey',
        swimming: 'Schwimmen',
        gymnastics: 'Turnen',
        dance: 'Tanzen',
        ballet: 'Ballett',
        tennis: 'Tennis',
        basketball: 'Basketball',
        judo: 'Judo',
        'horse-riding': 'Reiten',
        skating: 'Eislaufen',
        running: 'Laufen',
        cycling: 'Radfahren',
        playground: 'Spielplatz',
        'music-lesson': 'Musikunterricht',
        piano: 'Klavier',
        guitar: 'Gitarre',
        violin: 'Geige',
        drums: 'Schlagzeug',
        singing: 'Singen',
        theater: 'Theater',
        drawing: 'Zeichnen',
        painting: 'Malen',
        crafts: 'Basteln',
        puzzle: 'Puzzeln',
        play: 'Spielen',
        gaming: 'Zocken',
        tv: 'Fernsehen',
        'screen-time': 'Bildschirmzeit',
        dentist: 'Zahnarzt',
        doctor: 'Hausarzt',
        hospital: 'Krankenhaus',
        medicine: 'Medikamente',
        sick: 'Krank',
        haircut: 'Friseur',
        birthday: 'Geburtstag',
        party: 'Party',
        gift: 'Geschenk',
        wish: 'Wunsch',
        chat: 'Nachrichten',
        sohbet: 'Sohbet',
        grandma: 'Oma',
        grandpa: 'Opa',
        family: 'Familie',
        babysitter: 'Babysitter',
        playdate: 'Spielverabredung',
        sleepover: 'Übernachten',
        home: 'Zu Hause',
        holiday: 'Urlaub',
        travel: 'Reisen',
        camping: 'Camping',
        zoo: 'Zoo',
        museum: 'Museum',
        cinema: 'Kino',
        car: 'Auto',
        bus: 'Bus',
        train: 'Zug',
        walk: 'Spazieren',
        church: 'Kirche',
        shabbat: 'Schabbat',
        synagogue: 'Synagoge',
        mandir: 'Mandir',
        moon: 'Mond',
        breakfast: 'Frühstück',
        lunch: 'Mittagessen',
        dinner: 'Abendessen',
        fruit: 'Obst',
        drink: 'Trinken',
        cooking: 'Kochen',
        baking: 'Backen',
        groceries: 'Einkaufen',
        'ice-cream': 'Eis',
        popcorn: 'Filmabend',
        pizza: 'Pizza',
        pancakes: 'Pfannkuchen',
        soup: 'Suppe',
        'oven-dish': 'Auflauf',
        stamppot: 'Kartoffelstampf',
        lasagne: 'Lasagne',
        curry: 'Curry',
        noodles: 'Nudeln',
        taco: 'Tacos',
        wrap: 'Wrap',
        salad: 'Salat',
        hamburger: 'Hamburger',
        fries: 'Pommes',
        dumplings: 'Teigtaschen',
        waffle: 'Waffel',
        pie: 'Kuchen',
        cake: 'Gebäck',
        pudding: 'Nachtisch',
        banana: 'Banane',
        pear: 'Birne',
        orange: 'Orange',
        lemon: 'Zitrone',
        strawberry: 'Erdbeeren',
        grapes: 'Trauben',
        tomato: 'Tomate',
        cucumber: 'Gurke',
        carrot: 'Karotte',
        broccoli: 'Brokkoli',
        lettuce: 'Kopfsalat',
        'bell-pepper': 'Paprika',
        onion: 'Zwiebel',
        garlic: 'Knoblauch',
        potato: 'Kartoffeln',
        mushroom: 'Champignons',
        corn: 'Mais',
        avocado: 'Avocado',
        cheese: 'Käse',
        butter: 'Butter',
        egg: 'Eier',
        yoghurt: 'Joghurt',
        croissant: 'Croissant',
        honey: 'Honig',
        meat: 'Fleisch',
        chicken: 'Hähnchen',
        bacon: 'Speckwürfel',
        fish: 'Fisch',
        shrimp: 'Garnelen',
        sausage: 'Wurst',
        rice: 'Reis',
        salt: 'Salz',
        'canned-food': 'Dose',
        peanuts: 'Erdnüsse',
        chocolate: 'Schokolade',
        cookie: 'Kekse',
        jar: 'Glas',
        coffee: 'Kaffee',
        tea: 'Tee',
        juice: 'Saft',
        water: 'Wasser',
        'toilet-paper': 'Klopapier',
        soap: 'Seife',
        sponge: 'Schwamm',
        basket: 'Körbchen',
        'baby-bottle': 'Babynahrung',
        receipt: 'Kassenbon',
        store: 'Laden',
        star: 'Stern',
        trophy: 'Pokal',
        medal: 'Medaille',
        savings: 'Sparen',
        fox: 'Fuchs',
        cat: 'Katze',
        rabbit: 'Kaninchen',
        bear: 'Bär',
        panda: 'Panda',
        koala: 'Koala',
        owl: 'Eule',
        lion: 'Löwe',
        tiger: 'Tiger',
        monkey: 'Affe',
        unicorn: 'Einhorn',
        dino: 'Dino',
        turtle: 'Schildkröte',
        frog: 'Frosch',
        hedgehog: 'Igel',
        penguin: 'Pinguin',
        dolphin: 'Delfin',
        butterfly: 'Schmetterling',
        rocket: 'Rakete',
        sunflower: 'Sonnenblume',
        rainbow: 'Regenbogen',
        // Thema's (feat/themas): rustige, abstracte avatars.
        'shape-arch': 'Bogen',
        'shape-wave': 'Wellen',
        'shape-leaf': 'Blatt',
        'shape-hills': 'Hügel',
        'shape-ring': 'Ring',
        'shape-spark': 'Funke',
        towel: 'Handtuch',
        underwear: 'Unterhose',
        socks: 'Socken',
        'swim-trunks': 'Badehose',
        swimsuit: 'Badeanzug',
        shampoo: 'Shampoo',
        slippers: 'Badelatschen',
        'football-boots': 'Fußballschuhe',
        'shin-guards': 'Schienbeinschoner',
        'water-bottle': 'Trinkflasche',
        headscarf: 'Kopftuch',
        'prayer-cap': 'Gebetskappe',
    },
    pictoKeywords: {
        // Oprichter 1 okt: lezing, en sohbet (alleen bij Turks én Islam in het gezinsprofiel).
        lecture: 'vortrag vortraege vorlesung lecture lezing ders konferenz conference seminar',
        sohbet: 'sohbet sohbeti muhabbet',
        mosque: 'moschee moscheeunterricht masjid islam koran koranschule koranunterricht arabisch camii cami_ders kuran hafizlik',
        prayer: 'beten gebet gebete namaz salah salat teravih dua',
        wudu: 'wudu wudhu abdest abdest_almak wudu_machen gebetswaschung rituelle_waschung',
        quran: 'koran koranschule koranunterricht kuran quran hafiz hifz tajwid',
        church: 'kirche gottesdienst christlich kapelle sonntagsgottesdienst',
        shabbat: 'schabbat shabbat sabbat jüdisch',
        synagogue: 'synagoge jüdisch',
        mandir: 'mandir tempel hindu hinduistisch puja',
        moon: 'mond mondsichel halbmond ramadan',
        towel: 'handtuch badetuch',
        underwear: 'unterhose unterwäsche',
        socks: 'socken socke strümpfe',
        'swim-trunks': 'badehose',
        swimsuit: 'badeanzug bikini',
        shampoo: 'shampoo duschgel seife',
        slippers: 'badelatschen latschen flipflops',
        'football-boots': 'fußballschuhe stollenschuhe',
        'shin-guards': 'schienbeinschoner schoner',
        'water-bottle': 'trinkflasche wasserflasche',
        headscarf: 'kopftuch hijab tuch',
        'prayer-cap': 'takke gebetskappe gebetsmütze kufi',
    },
    pictoCategory: {
        routine: 'Tagesablauf',
        chores: 'Haushalt',
        school: 'Schule und Arbeit',
        sport: 'Sport',
        hobby: 'Musik und Hobby',
        care: 'Gesundheit',
        family: 'Familie und Ausflüge',
        food: 'Essen',
        groceries: 'Einkaufen',
        reward: 'Belohnung',
        avatar: 'Tiere und Figuren',
        packing: 'Einpacken',
    },
    color: {
        orange: 'Orange',
        skyblue: 'Hellblau',
        bluishgreen: 'Grün',
        yellow: 'Gelb',
        blue: 'Blau',
        vermillion: 'Rot',
        reddishpurple: 'Rosa',
        black: 'Grau',
    },
    eventCard: {
        allDay: 'Ganztägig',
        cancelled: 'Abgesagt',
        everyone: 'Alle',
        whoDrives: 'Wer fährt?',
        drives: '{name} fährt',
        splitDrives: '{dropoff} bringt · {pickup} holt',
        repeat: 'Wiederholt sich',
        moved: 'Verschoben',
        changed: 'Geändert',
    },
    check: {
        label: '{task}: fertig?',
        confirm: 'Fertig!',
        undo: 'Hoppla',
    },
    points: {
        earned: { one: '{count} Punkt', other: '{count} Punkte' },
        reserved: '{count} reserviert',
    },
    progress: '{done} von {total} fertig',
    celebrate: {
        task: 'Gut gemacht, {name}!',
        allDone: 'Alles fertig!',
        /** Rustig, buiten het thema Kinderen (oprichter okt 2026: geen uitroeptekens of lof). */
        calm: {
            confirm: 'Erledigt',
            task: 'Erledigt von {name}',
            allDone: 'Für heute ist alles erledigt',
        },
    },
    colorPicker: {
        label: 'Farbe',
        takenBy: 'Schon gewählt von {name}',
        takenOne: '{color} gehört schon {name}',
    },
    iconPicker: {
        label: 'Symbol',
        search: 'Symbol suchen',
        none: 'Kein Symbol',
        noResults: 'Nichts gefunden für „{query}“',
        all: 'Alle',
        more: '+{count} weitere',
    },
    toast: {
        undo: 'Rückgängig',
        dismiss: 'Hinweis schließen',
    },
    dialog: {
        close: 'Schließen',
        fullScreen: 'Vollbild',
        smallScreen: 'Verkleinern',
    },
    calendar: {
        weekShort: 'KW',
        more: '+{count} weitere',
        moreShort: '+{count}',
        now: 'Jetzt',
    },
    editor: {
        title: 'Titel',
        titleHint: 'Kurz und klar, zum Beispiel Schwimmkurs',
        repeat: 'Wiederholen',
        repeatNone: 'Nie',
        repeatDaily: 'Jeden Tag',
        repeatWeekly: 'Jede Woche am {weekday}',
        repeatMonthly: 'Jeden Monat',
        duplicate: 'Duplizieren',
        approvalRequired: 'Bestätigung nötig',
        approvalHint: 'Mama oder Papa bestätigt die Aufgabe, bevor die Punkte zählen.',
        deleteQuestion: '{title} löschen?',
        repeatsWeekly: 'Dieser Termin wiederholt sich jede Woche.',
    },
    scope: {
        editTitle: 'Was möchtest du ändern?',
        deleteTitle: 'Was möchtest du löschen?',
        this: 'Nur dieses Mal',
        following: 'Dieses und folgende',
        all: 'Die ganze Serie',
        times: { one: '{count}-mal', other: '{count}-mal' },
        from: 'ab {date}',
    },
    view: {
        label: 'Ansicht',
        day: 'Tag',
        week: 'Woche',
        month: 'Monat',
    },
    inbox: {
        label: 'Bestätigen',
        open: 'Offen',
        done: 'Erledigt',
    },
    empty: {
        welcomeTitle: 'Willkommen zu Hause',
        welcomeBody: 'Gemeinsam die Woche im Blick, ohne Stress. Wir fangen mit deiner Familie an.',
        emptyDayTitle: 'Heute nichts geplant',
        emptyDayBody: 'Ein ruhiger Tag. Zeit für etwas Schönes?',
        noTasksTitle: 'Heute keine Aufgaben',
        noTasksBody: 'Heute mal frei!',
        allDoneTitle: 'Alles erledigt',
        allDoneBody: 'Es ist nichts mehr offen.',
        offlineTitle: 'Gerade keine Verbindung',
        offlineBody: 'Du siehst den letzten Stand. Das wird von selbst wieder.',
        nightTitle: 'Schlaf gut',
        nightBody: 'Morgen um {time}: {title}',
        rewardsTitle: 'Noch keine Belohnungen',
        rewardsBody: 'Überlegt euch zusammen etwas, worauf ihr sparen wollt.',
        inviteTitle: 'Lade deinen Partner ein',
        inviteBody: 'Zusammen planen ist leichter. Schick eine Einladung per E-Mail.',
        oopsTitle: 'Hoppla, da ging etwas schief',
        oopsBody: 'Versuch es noch einmal. Klappt es nicht? Lade die Seite neu.',
        pairTitle: 'Tablet koppeln',
        pairBody: 'Öffne das Familienboard auf dem Tablet und gib den Code hier ein.',
    },
    credits: 'Piktogramme, Icons und Illustrationen: AMUMIN',
    gallery: {
        title: 'Designgalerie',
        intro: 'Alle Bausteine des Familienboards an einem Ort: Tokens, Komponenten, Piktogramme und Illustrationen. Nur in der Entwicklungsumgebung sichtbar.',
        theme: 'Thema',
        themeLight: 'Tag',
        themeDark: 'Abend',
        themeNight: 'Nacht',
        colors: 'Farben',
        memberColors: 'Mitgliederfarben',
        neutrals: 'Neutraltöne',
        semantic: 'Bedeutung',
        typography: 'Typografie',
        spacing: 'Abstände und Formen',
        kiosk: 'Kiosk-Bausteine',
        web: 'Webapp-Bausteine',
        icons: 'Icons',
        pictograms: 'Piktogramme',
        illustrations: 'Illustrationen',
        sample: 'Beispiel',
    },
};
//# sourceMappingURL=design.de.js.map